import { Box, Button, Flex, HStack, IconButton, Text } from "@chakra-ui/react";
import React from "react";
import { FiAlertCircle, FiLock, FiX } from "react-icons/fi";

/**
 * Quota Banner Component
 * Displays a dismissible banner when user is running low on quota
 * 
 * @param {Object} props
 * @param {Object} props.quota - Quota information
 * @param {boolean} props.show - Should banner be shown
 * @param {Function} props.onDismiss - Dismiss handler
 * @param {Function} props.onUpgrade - Upgrade button handler
 */
const QuotaBanner = ({ quota, show, onDismiss, onUpgrade }) => {
  if (!show) return null;

  const { remaining } = quota;
  const isExhausted = remaining === 0;

  return (
    <Flex justify="center" mb={6}>
      <Box
        maxW="600px"
        w="full"
        bg={isExhausted ? "purple.50" : "orange.50"}
        border="1px solid"
        borderColor={isExhausted ? "purple.200" : "orange.200"}
        borderRadius="2xl"
        px={4}
        py={3}
        boxShadow="sm"
      >
        <Flex justify="space-between" align="center" gap={3}>
          <HStack spacing={2} flex="1">
            <Box
              as={isExhausted ? FiLock : FiAlertCircle}
              color={isExhausted ? "purple.500" : "orange.500"}
              size="16px"
              flexShrink={0}
            />
            <Text fontSize="sm" color="gray.700" fontWeight="500">
              {isExhausted ? (
                <>Upgrade to analyze more jobs</>
              ) : (
                <>
                  Only <strong>{remaining}</strong>{" "}
                  {remaining === 1 ? "analysis" : "analyses"} left
                </>
              )}
            </Text>
          </HStack>
          <HStack spacing={2}>
            <Button
              size="xs"
              colorScheme={isExhausted ? "purple" : "orange"}
              onClick={onUpgrade}
              fontWeight="600"
              borderRadius="lg"
              px={3}
            >
              Upgrade
            </Button>
            <IconButton
              size="xs"
              icon={<FiX />}
              variant="ghost"
              aria-label="Dismiss banner"
              onClick={onDismiss}
              color="gray.500"
              _hover={{ bg: "gray.100" }}
              borderRadius="lg"
            />
          </HStack>
        </Flex>
      </Box>
    </Flex>
  );
};

export default QuotaBanner;
